import { render, staticRenderFns } from "./ExtendInspection.vue?vue&type=template&id=6bf67a04&scoped=true&"
import script from "./ExtendInspection.vue?vue&type=script&lang=ts&"
export * from "./ExtendInspection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf67a04",
  null
  
)

export default component.exports